'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var jsep = _interopDefault(require('jsep'));

function handleSyntaxErrors(error) {
  var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var newError = new Error('Syntax error');
  newError.type = 'SyntaxError';
  newError.index = error.index;
  newError.description = error.description || error.message;

  if (/expression/.test(newError.description)) {
    newError.description = newError.description.replace('expression', 'value');
  }

  if (newError.description === 'Unexpected ') {
    newError.description = 'Unexpected input';
  }

  if (/literal\(\s*{/.test(input)) {
    newError.description = 'Only array arguments are supported for the literal expression';
  }

  return newError;
}

// GL expressions use ^ for exponentiation, while JS uses **.
// 15 is precedence of ** operator in JS.
jsep.addBinaryOp('^', 15);

function handleLiteralArgument(arg) {
  switch (arg.type) {
    case 'ArrayExpression':
      return arg.elements.map(function (item) {
        if (item.type === 'Literal') return item.value;
        return handleLiteralArgument(item);
      });
    default:
      throw handleSyntaxErrors(new Error('Invalid syntax'));
  }
}

function astToExpression(input) {
  if (input.type === 'Identifier') {
    throw handleSyntaxErrors(new Error('Unexpected identifier'));
  }

  if (input.value !== undefined) return input.value;
  if (input.name !== undefined) return input.name;

  var expressionOperator = void 0;
  var expressionArguments = [];

  if (input.type === 'ArrayExpression') {
    return input.elements.map(astToExpression);
  }

  if (input.type === 'UnaryExpression') {
    expressionOperator = input.operator;
    expressionArguments.push(astToExpression(input.argument));
  }

  if (input.type === 'BinaryExpression') {
    expressionOperator = input.operator === '&' ? 'concat' : input.operator;

    // Collapse concat arguments, in case the & operator was used to join
    // more than two successive strings.
    var addBinaryArgument = function addBinaryArgument(arg) {
      if (expressionOperator === 'concat' && Array.isArray(arg) && arg[0] === 'concat') {
        expressionArguments = expressionArguments.concat(arg.slice(1));
      } else {
        expressionArguments.push(arg);
      }
    };
    addBinaryArgument(astToExpression(input.left));
    addBinaryArgument(astToExpression(input.right));
  }

  if (input.type === 'CallExpression') {
    expressionOperator = input.callee.name;

    if (expressionOperator === 'literal') {
      expressionArguments = expressionArguments.concat(input.arguments.map(handleLiteralArgument));
    } else {
      input.arguments.forEach(function (i) {
        expressionArguments.push(astToExpression(i));
      });
    }
  }

  // Change undescores in expression operators to hyphens, reversing the
  // transformation below.
  if (/[a-z]+_[a-z]+/.test(expressionOperator)) {
    expressionOperator = expressionOperator.replace(/([a-z]+)_([a-z]+)/, '$1-$2');
  }

  return [expressionOperator].concat(expressionArguments);
}

function formulaToExpression(input) {
  if (input === '' || input === undefined) {
    return;
  }

  if (typeof input !== 'string') {
    throw new Error('input must be a string');
  }

  // Change hyphens in expression operators to underscores. This allows JS
  // parsing to work, but then needs to be reversed above.
  input = input.replace(/([a-z]+)-([a-z]+)\(/, '$1_$2(');

  var ast = void 0;
  try {
    ast = jsep(input);
  } catch (syntaxError) {
    throw handleSyntaxErrors(syntaxError, input);
  }

  var expression = astToExpression(ast);
  return expression;
}

// DO NOT MODIFY DIRECTLY!
// This file is generated by scripts/build-operator-whitelist.js
// from the Mapbox GL Style Spec.

var operators = new Set();

operators.add('let');
operators.add('var');
operators.add('literal');
operators.add('array');
operators.add('at');
operators.add('case');
operators.add('match');
operators.add('coalesce');
operators.add('step');
operators.add('interpolate');
operators.add('ln2');
operators.add('pi');
operators.add('e');
operators.add('typeof');
operators.add('string');
operators.add('number');
operators.add('boolean');
operators.add('object');
operators.add('to-string');
operators.add('to-number');
operators.add('to-boolean');
operators.add('to-rgba');
operators.add('to-color');
operators.add('rgb');
operators.add('rgba');
operators.add('get');
operators.add('has');
operators.add('length');
operators.add('properties');
operators.add('feature-state');
operators.add('geometry-type');
operators.add('id');
operators.add('zoom');
operators.add('heatmap-density');
operators.add('line-progress');
operators.add('+');
operators.add('*');
operators.add('-');
operators.add('/');
operators.add('%');
operators.add('^');
operators.add('sqrt');
operators.add('log10');
operators.add('ln');
operators.add('log2');
operators.add('sin');
operators.add('cos');
operators.add('tan');
operators.add('asin');
operators.add('acos');
operators.add('atan');
operators.add('min');
operators.add('max');
operators.add('round');
operators.add('abs');
operators.add('ceil');
operators.add('floor');
operators.add('==');
operators.add('!=');
operators.add('>');
operators.add('<');
operators.add('>=');
operators.add('<=');
operators.add('all');
operators.add('any');
operators.add('!');
operators.add('upcase');
operators.add('downcase');
operators.add('concat');

function stringifyLiteralArray(arr) {
  var items = arr.map(function (item) {
    if (Array.isArray(item)) return stringifyLiteralArray(item);
    return JSON.stringify(item);
  });
  return '[' + items.join(', ') + ']';
}

function isInfixOperator(operator) {
  if (operator === '!') return false;
  return (/^[^a-zA-Z]/.test(operator)
  );
}

function expressionToFormula(expression) {
  if (!Array.isArray(expression)) {
    throw new Error('Input must be an array');
  }

  var operator = expression[0];

  if (!operators.has(operator)) {
    return stringifyLiteralArray(expression);
  }

  if (operator === 'literal') {
    var arg = expression[1];
    if (!Array.isArray(arg)) {
      throw new Error('Only array arguments are supported for the literal expression');
    }
    return operator + '(' + stringifyLiteralArray(arg) + ')';
  }

  var args = expression.slice(1).map(function (arg) {
    if (typeof arg === 'string') {
      return '"' + arg + '"';
    }
    if (!Array.isArray(arg)) {
      return arg;
    }
    var argOperator = arg[0];
    var argFormula = expressionToFormula(arg);
    if (
    // Use parentheses to deal with operator precedence.
    /^[+-]$/.test(argOperator) && /^[*/%]$/.test(operator) || operator === '^') {
      return '(' + argFormula + ')';
    }
    return argFormula;
  });

  if (operator === '^') {
    return '' + args.join(operator);
  }

  if (isInfixOperator(operator)) {
    return '' + args.join(' ' + operator + ' ');
  }

  if (operator === 'concat') {
    return args.join(' & ');
  }

  return operator + '(' + args.join(', ') + ')';
}

var index = {
  formulaToExpression: formulaToExpression,
  expressionToFormula: expressionToFormula
};

module.exports = index;
